<script>
import ViewTitle from '@/components/ViewTitle'
import WideIconTile from '@/components/WideIconTile'
import SvgBackground from '@/components/SvgBackground'
import CovidServices from '@/services/covid'
import DateUtils from '@/utils/dateUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import StringUtils from '@/utils/stringUtils'
import EnvironmentUtils from '@/utils/environmentUtils'

export default
{
    name: 'covid',

    created ()
    {
        CovidServices.getCovidHelp(EnvironmentUtils.cityId).then(help =>
        {
            this.$store.commit('covid/setCovidHelp', help)
        })
        CovidServices.getHealthStatsForDate(DateUtils.add(new Date(), {days: -4})).then(stats =>
        {
            this.$store.commit('covid/updateHealthStats', stats)
        })
        CovidServices.getHealthStatsForDate(DateUtils.add(new Date(), {days: -2})).then(stats =>
        {
            this.$store.commit('covid/updateHealthStats', stats)
        })
        CovidServices.getHealthStatsForDate(DateUtils.add(new Date(), {days: -1})).then(stats =>
        {
            this.$store.commit('covid/updateHealthStats', stats)
        })
    },

    render () 
    {
        return (
            <div id='covid-view'>
                <view-title>Informations et ressources COVID-19</view-title>
                {
                    this.latestCovidStats &&
                    <div class='health-stats'>
                        <div class='section-title'>Aujourd'hui dans {EnvironmentUtils.cityDepartmentWithPronoun} (cumulé)</div>
                        <div class='row'>
                            <div class='counter error'>
                                <div class='value'>{StringUtils.insertEvery(this.latestCovidStats.deces || 0, 3, ' ', {startFromEnd: true})}</div>
                                <div class='name'>Décés</div>
                            </div>
                            <div class='counter success'>
                                <div class='value'>{StringUtils.insertEvery(this.latestCovidStats.gueris || 0, 3, ' ', {startFromEnd: true})}</div>
                                <div class='name'>Guérisons</div>
                            </div>
                            <div class='counter warning'>
                                <div class='value'>{StringUtils.insertEvery(this.latestCovidStats.nouvellesHospitalisations || 0, 3, ' ', {startFromEnd: true})}</div>
                                <div class='name'>Nouveaux cas</div>
                            </div>
                        </div>
                        <div class='text'>Nos salles de réanimation sont occupées à {this.latestCovidStats.tauxOccupationRea}%</div>
                        <div class='stats-source'>Statistiques de <a href='https://dashboard.covid19.data.gouv.fr/vue-d-ensemble?location=FRA' target='_system'>data.gouv.fr</a></div>
                    </div>
                }
                {
                    this.comfortMessage && this.comfortMessage.text &&
                    <div class='quote'>
                        <div class='quote-text'>{ this.comfortMessage.text }</div>
                        <div class='quote-source'>
                            <div class='column text'>
                                <div class='name'>{ this.comfortMessage.writer.name }</div>
                                <div class='title'>{ this.comfortMessage.writer.title }</div>
                            </div>
                            <img class='picture' src={this.comfortMessage.writer.pictureUrl} />
                        </div>
                    </div>
                }
                <div class='certificate-templates'>
                    <div class='section-title'>Mes attestations de déplacement</div>
                    {
                        LocalStorageUtils.covidCertificateTemplates.map(u =>
                        {
                            const subtitle = `${u.firstName} ${u.lastName} ${u.birthDate}`

                            return <wide-icon-tile title={u.firstName} subtitle={subtitle} icon={<svg-background src={require('@/assets/img/circle.svg')}>
                                <inline-svg src={require('@/assets/img/user.svg')} /></svg-background>}
                                on-click={() => this.$router.push({path: 'certificates/generate', query: {user: JSON.stringify(u)}, append: true})} />
                        })
                    }
                    <wide-icon-tile title='Créer un nouveau modèle' on-click={() => this.$router.push({path: 'certificates/new', append: true})}
                        icon={<svg-background src={require('@/assets/img/circle.svg')}><inline-svg src={require('@/assets/img/plus.svg')} /></svg-background>} />
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },
    
    computed:
    {
        comfortMessage ()
        {
            return this.$store.state.covid.covidHelp.comfortMessage
        },

        latestCovidStats ()
        {
            const stats = Object.values(this.$store.getters.covid.getHealthStatsForZipcode(EnvironmentUtils.cityZipcode)).filter(d => d)[0]

            return stats
        }
    },

    methods:
    {
    },

    components:
    {
        ViewTitle,
        WideIconTile,
        SvgBackground
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#covid-view
{
    display: flex;
    flex-direction: column;
    margin: 0 10px;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);

    .OnDesktop({
        margin-top: 4vw;
        margin-left: 10vw;
        margin-right: 10vw;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });

    .row
    {
        display: flex;
        flex-direction: row;
    }

    .section-title
    {
        font-weight: 500;
        font-size: 20px;
        margin-bottom: 10px;
    }

    .health-stats
    {
        .counter
        {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-grow: 1;
            background-color: var(--theme-content-background-color);
            padding: 10px;
            border-radius: 6px;

            &:not(:first-of-type)
            {
                margin-left: 10px;
            }
            
            &::before, &::after
            {
                display: block;
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0px;
                top: 0px;
                border-radius: inherit;
                content: "";
            }
            &::before
            {
                box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
            }
            &::after
            {
                box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
            }

            &.error
            {
                color: var(--theme-danger-color);
            }
            &.success
            {
                color: var(--theme-success-color);
            }
            &.warning
            {
                color: #ffa500;
            }

            .value
            {
                font-size: 30px;
                font-weight: 500;
                font-size: 8vw;

                .OnDesktop({ font-size: 3vw; });
            }

            .name
            {
                color: var(--theme-text-color-light);
                margin-top: 5px;
                font-size: 4.7vw;

                .OnDesktop({ font-size: 1.5vw; });
            }
        }

        .text
        {
            margin-top: 10px;
        }

        .stats-source
        {
            font-size: 13px;
        }
    }

    .quote
    {
        margin-top: 30px;

        .quote-text
        {
            position: relative;
            padding: 15px 20px;
            border-radius: 14px;
            background-color: var(--theme-content-background-color);
            box-shadow: var(--theme-box-shadow-diffuse);

            // bubble ending rounded
            &::before
            {
                display: block;
                position: absolute;
                width: 30px;
                height: 30px;
                right: 31px;
                bottom: -10px;
                border-radius: 8px;
                background-color: inherit;
                content: "";
                transform: rotate(45deg);
            }
        }

        .quote-source
        {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 10px;

            .text
            {
                margin-left: auto;
                margin-right: 10px;
                font-size: 13px;

                .name
                {
                    font-weight: 600;
                }

                .title
                {
                    text-align: right;
                }
            }

            .picture
            {
                .WidthHeight(40px);
                border-radius: 100%;
            }
        }
    }

    .certificate-templates
    {
        margin-top: 50px;

        .svg-background
        {
            .background
            {
                fill: var(--theme-border-color);
            }

            .content
            {
                padding: 8px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Covid.vue